import React from "react";

type Props = {};
type State = {};
export class Visitor404NotFound extends React.Component<Props, State> {
	render() {
		return (
			<div style={{textAlign: "center"}}>
				<h2>Visitor 404 Not found!</h2>
			</div>
		);
	}
}